export default __webpack_public_path__ + "c8c73d63376da998c8f00b29d8a8d97d.gif";